import React from 'react';
import { Link } from 'react-router-dom';
import { AlertTriangle, ExternalLink } from 'lucide-react';
import { Button } from './ui/button';

/**
 * Banner mostrato quando un artigiano non ha ancora completato l'onboarding Stripe.
 * `variant`: 'client' | 'crafter-own'
 *   - client: messaggio "questo artigiano non è ancora attivo per la vendita"
 *   - crafter-own: messaggio verso l'artigiano stesso, con CTA verso la dashboard pagamenti
 */
export const CrafterStripeStatusBanner = ({
  variant = 'client',
  crafterName = 'questo artigiano',
  className = '',
}) => {
  if (variant === 'crafter-own') {
    return (
      <div
        className={`rounded-xl border-2 border-amber-300 bg-gradient-to-r from-amber-50 to-yellow-50 p-4 sm:p-5 ${className}`}
        data-testid="crafter-stripe-banner-own"
      >
        <div className="flex items-start gap-3">
          <div className="flex-shrink-0 w-10 h-10 rounded-full bg-amber-200 text-amber-800 flex items-center justify-center">
            <AlertTriangle className="w-5 h-5" />
          </div>
          <div className="flex-1 min-w-0">
            <h3 className="font-bold text-amber-900 mb-1">
              Attiva i pagamenti per iniziare a vendere
            </h3>
            <p className="text-sm text-amber-800 leading-relaxed mb-3">
              Per motivi fiscali e di sicurezza, i tuoi prodotti non sono ancora
              acquistabili dai clienti. Completa l&apos;attivazione Stripe
              (~5 minuti) per ricevere ordini e pagamenti direttamente sul tuo
              conto. Rarifex non trattiene i tuoi soldi.
            </p>
            <Button
              asChild
              className="bg-amber-600 hover:bg-amber-700 text-white"
              data-testid="crafter-stripe-banner-cta"
            >
              <Link to="/dashboard?tab=artigiano&section=pagamenti">
                Attiva pagamenti Stripe
                <ExternalLink className="w-4 h-4 ml-2" />
              </Link>
            </Button>
          </div>
        </div>
      </div>
    );
  }

  // variant === 'client'
  return (
    <div
      className={`rounded-xl border border-slate-300 bg-slate-50 p-4 ${className}`}
      data-testid="crafter-stripe-banner-client"
    >
      <div className="flex items-start gap-3">
        <div className="flex-shrink-0 w-9 h-9 rounded-full bg-slate-200 text-slate-700 flex items-center justify-center">
          <AlertTriangle className="w-4 h-4" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-sm font-semibold text-slate-800">
            Artigiano in fase di attivazione
          </p>
          <p className="text-xs text-slate-600 mt-1 leading-relaxed">
            {crafterName} sta completando la verifica dei pagamenti e
            momentaneamente non può ricevere ordini. Puoi comunque salvare
            i suoi prodotti nei preferiti o inviare un messaggio.
          </p>
        </div>
      </div>
    </div>
  );
};

export default CrafterStripeStatusBanner;
